
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"14","viewBox":"0 0 10 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":"0.4","d":"M0 5L5 0L10 5H0Z","fill":"#fff"}}),_c('path',{attrs:{"opacity":"0.4","d":"M0 9L5 14L10 9H0Z","fill":"#fff"}})])
          )
        }
      }
    